'use client'

import React from 'react'
import Image from 'next/image'
import Link from 'next/link'
import { useModal } from '@/blocks/redesign_blocks/Modal/ModalContext'
import AnimatedSection from '@/components/AnimatedSection'
import Typography from '@/components/Typography'
import styles from './styles.module.css'

const cards = [
	{
		title: 'Сайты и приложения',
		description: 'Разрабатываем цифровые продукты под задачи вашего бизнеса. Создаём корпоративные сайты, личные кабинеты, маркетплейсы и веб-приложения с фокусом на удобство пользователей и высокую производительность.',
		image: '/images/services/custom-development-site.svg',
		link: '/services/development',
		buttons: [
			{ text: 'Корпоративные сайты', href: '#' },
			{ text: 'Личные кабинеты', href: '#' },
			{ text: 'Веб-приложения', href: '#' },
			{ text: 'eCommerce и маркетплейсы', href: '#' }
		]
	},
	{
		title: 'Интеграции',
		description: 'Объединяем разрозненные ИТ-системы в единый работающий механизм. Настраиваем бесшовный обмен данными между сайтом, 1С, CRM и банками для автоматизации процессов и исключения ручных ошибок.',
		image: '/images/services/custom-development-integration.svg',
		link: '/services/integrations',
		buttons: [
			{ text: 'Интеграция с 1С', href: '#' },
			{ text: 'Интеграции с банками', href: '#' },
			{ text: 'CRM', href: '#' },
			{ text: 'Системные интеграции', href: '#' }
		]
	},
	{
		title: 'Комплексные решения',
		description: 'Реализуем масштабные ИТ-проекты «под ключ» для корпораций и госсектора. Берём на себя весь цикл создания цифровых экосистем: от глубокой аналитики и проектирования архитектуры до внедрения, сопровождения и развития.',
		image: '/images/services/custom-development-solutions.svg',
		link: '/services/complex-solutions',
		buttons: [
			{ text: 'Для государства', href: '#' },
			{ text: 'Для бизнеса', href: '#' }
		]
	}
]

const CustomDevelopment: React.FC = () => {
	const { openConsultationModal } = useModal()

	return (
		<section className={styles.section}>
			<AnimatedSection animation="slideUp">
				<div className={styles.heading}>
					<Typography variant='h4' color='accent' className={styles.subtitle}>
						Цифровая трансформация бизнеса
					</Typography>
					<Typography variant='h2' className={styles.title}>
						Заказная разработка
					</Typography>
				</div>
			</AnimatedSection>

			<div className={styles.cards}>
				{cards.map((card, idx) => (
					<AnimatedSection key={idx} animation="slideUp">
						<div className={styles.card}>
							<div className={styles.cardImage}>
								<Image
									src={card.image}
									alt={card.title}
									width={310}
									height={310}
									className={styles.image}
								/>
							</div>
							<div className={styles.cardContent}>
								<Typography variant='h3' className={styles.cardTitle}>
									{card.title}
								</Typography>
								<Typography variant='p1' color='description' className={styles.cardDescription}>
									{card.description}
								</Typography>
								<Link href={card.link} className={styles.link}>
									<div className={styles.linkContent}>
										<span className={styles.linkText}>Подробнее</span>
										<div className={styles.linkIcon}>
											<svg width="16" height="16" viewBox="0 0 16 16" fill="none">
												<path d="M6.33333 3V4.33333H10.7267L3 12.06L3.94 13L11.6667 5.27333V9.66667H13V3H6.33333Z" fill="#f23b67" />
											</svg>
										</div>
									</div>
								</Link>
								<div className={styles.buttonsContainer}>
									{card.buttons.map((button, btnIdx) => (
										<Link 
											key={btnIdx}
											href={button.href}
											className={styles.consultationButton}
										>
											<span className={styles.consultationButtonText}>{button.text}</span>
											<svg className={styles.consultationButtonIcon} viewBox="0 0 16 16" fill="none">
												<path d="M6.33333 3V4.33333H10.7267L3 12.06L3.94 13L11.6667 5.27333V9.66667H13V3H6.33333Z" fill="var(--color-brand-white)" />
											</svg>
										</Link>
									))}
								</div>
							</div>
						</div>
					</AnimatedSection>
				))}
			</div>
		</section>
	)
}

CustomDevelopment.displayName = 'CustomDevelopment'

export default CustomDevelopment

